import TextInput from 'common/components/inputs/text/TextInput';
import React from 'react';
import { FormGroup, FormLabel } from 'react-bootstrap';

interface IUsernameInput {
  onChange: (value: string) => void;
  error: string | undefined;
}

const UsernameInput = (props: IUsernameInput) => {
  return (
    <FormGroup>
      <FormLabel htmlFor='username'>Email address</FormLabel>
      <TextInput
        id='username'
        name='username'
        type='text'
        autoComplete='username'
        onChange={(e) => {
          e.preventDefault();
          const { value } = e.target;
          props.onChange(value);
        }}
        error={props.error}
      />
    </FormGroup>
  );
};

export default UsernameInput;
